import { jsx as _jsx } from "react/jsx-runtime";
import { useFormattedOfferedMaxTerms } from "@faire/retailer-visitor-shared/hooks/openWithFaire/useFormattedOfferedMaxTerms";
import { MediumFormatting } from "@faire/web--source/common/localization/formatting";
import { Button } from "@faire/web--source/slate/Button";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { Medium } from "@faire/web--source/ui/Typography/Span";
import { trackOpenWithFaireOwfGlobalUpsellBannerClick } from "@faire/web-api--source/events/openWithFaire/click/owfGlobalUpsellBanner";
import { trackOpenWithFaireOwfGlobalUpsellBannerView } from "@faire/web-api--source/events/openWithFaire/view/owfGlobalUpsellBanner";
import openWithFaire from "@faire/web-api--source/routes/open-with-faire";
import React, { useEffect } from "react";
export var OpenWithFaireEligibleToApplyBanner = function() {
    var formattedOfferedMaxTerms = useFormattedOfferedMaxTerms();
    useEffect(function() {
        trackOpenWithFaireOwfGlobalUpsellBannerView();
    }, []);
    return /*#__PURE__*/ _jsx(Typography, {
        align: "center",
        "data-test-id": "open-with-faire-eligible-to-apply-banner",
        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "wszcOi",
            defaultMessage: [
                {
                    type: 0,
                    value: "Get up to "
                },
                {
                    type: 8,
                    value: "MediumFormatting",
                    children: [
                        {
                            type: 1,
                            value: "maxTermsLimitMoney"
                        },
                        {
                            type: 0,
                            value: " in payment terms"
                        }
                    ]
                },
                {
                    type: 0,
                    value: " when you apply for Open with Faire. "
                },
                {
                    type: 8,
                    value: "LinkFormatting",
                    children: [
                        {
                            type: 0,
                            value: "Learn more"
                        }
                    ]
                }
            ],
            values: {
                MediumFormatting: MediumFormatting,
                maxTermsLimitMoney: formattedOfferedMaxTerms,
                LinkFormatting: LinkFormatting
            }
        })
    });
};
var LinkFormatting = function(chunk) {
    return /*#__PURE__*/ _jsx(Button, {
        variant: "tertiary",
        linkTo: openWithFaire(),
        onClick: trackOpenWithFaireOwfGlobalUpsellBannerClick,
        children: /*#__PURE__*/ _jsx(Medium, {
            children: chunk
        })
    });
};
